<div
  (click)="onClick()" (dblclick)="onDoubleClick()"
  class="wrapper {{tunifyColor == TunifyColor.BLUE ? 'blue' : (tunifyColor == TunifyColor.GREEN ? 'green' : 'orange')}} {{isSelected ? 'selected-item' : ''}}">
  <!--
  <div *ngIf="useSelectionBox" class="checkbox-container">
    <tun-checkbox-v5
      class="checkbox {{showSelectionBox ? 'checkbox-force-visible' : ''}}"
      [checkBoxColor]="checkBoxColor"
      [isChecked]="isSelected"
      (isCheckedChanged)="onCheckedChange($event)"
      >
    </tun-checkbox-v5>
  </div>
  -->
  <div class="play-button-container">

    <button
      class="play-button icon-button {{playEnabled ? '' : 'disable-button'}} {{!showAddButton ? 'play-button-force-visible' : ''}}"
      [matTooltip]="(isPlaying ? (isPlayActive ? 'trackOptions.tooltip.play.pause': 'trackOptions.tooltip.play.resume') : 'trackOptions.tooltip.play.start') | translate"
      (click)="onTogglePlay($event)">
      @if (!isPlaying || !isPlayActive) {
        <tun-play-track class="icon {{showSelectionBox ? '' : 'colored-icon'}}"></tun-play-track>
      }
      @if (isPlaying && isPlayActive) {
        <tun-pause-track-v5 class="icon {{showSelectionBox ? '' : 'colored-icon'}}"></tun-pause-track-v5>
      }
    </button>

  </div>

  <!-- add to queue -->
  @if (showAddButton && addToPlaylist == null) {
    <div class="add-button-container">
      @if (!isPlaying) {
        <button
          [disabled]="isAdded"
          [matTooltip]="addButtonTooltip"
          class="icon-button {{addEnabled ? '' : 'disable-button'}}"
          (click)="onAdd($event)">
          @if (!isAdded) {
            <tun-add-to-queue-v5 class="icon icon-add-to-queue"></tun-add-to-queue-v5 >
          }
          @if (isAdded) {
            <tun-checkmark-icon-v5 class="icon icon-small"></tun-checkmark-icon-v5>
          }
        </button>
      }
      @if (isPlaying) {
        <tun-music-play-animation
          class="playAnimationContainer"
          [playing]="isPlayActive"
          [musicPlayAnimationColors]="playAnimationColors"
          >
        </tun-music-play-animation>
      }
    </div>
  }

  <!-- add to playlist -->
  @if (showAddButton && addToPlaylist) {
    <div class="add-button-container">
      <button
        [disabled]="isAdded"
        [matTooltip]="addButtonTooltip"
        class="icon-button {{addEnabled ? '' : 'disable-button'}}"
        (click)="onAdd($event)">
        @if (!isAdded) {
          <tun-plus-icon-v5 class="icon icon-add-to-queue"></tun-plus-icon-v5 >
        }
        @if (isAdded) {
          <tun-checkmark-icon-v5 class="icon icon-small"></tun-checkmark-icon-v5>
        }
      </button>
      @if (isPlaying) {
        <tun-music-play-animation
          class="playAnimationContainer"
          [playing]="isPlayActive"
          [musicPlayAnimationColors]="playAnimationColors"
          >
        </tun-music-play-animation>
      }
    </div>
  }


  <div class="trackContent">
    <div class="trackTitleContainer">
      <tun-scrollable-text class="trackTitle" [text]="track.title"></tun-scrollable-text>
    </div>
    <div class="trackGroupContainer">
      <tun-scrollable-text class="trackGroup" [text]="track.group"></tun-scrollable-text>
    </div>
  </div>

  @if (showAudioFileProperty != null) {
    <div class="trackPropertyContent">
      <tun-scrollable-text class="trackProperty" [text]="trackPropertyText"></tun-scrollable-text>
    </div>
  }

  <button
    class="icon-button"
    [matTooltip]="'trackOptions.tooltip.info' | translate"
    (click)="onOptions($event)"
    >
    <tun-track-options class="icon"></tun-track-options>
  </button>

</div>
